<template>
  <div class="info-acao-container">
    <Carregamento v-if="carregando" />

    <div
      v-else
      class="info-acao-wrapper"
    >
      <!-- Título da seção separado -->
      <div class="info-titulo-secao">
        <h3>Informações da Ação</h3>
        <div class="botoes-topo">
          <button
            v-if="!modoEditar"
            type="button"
            class="btn-membros-equipe"
            @click="abrirModalMembros"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"/>
            </svg>
            Ver membros da equipe
          </button>

          <button
            v-if="!modoEditar && isCoordenadorDaAcao"
            type="button"
            class="btn-editar-principal"
            @click="ativarModoEditar"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
              />
              <path
                fill-rule="evenodd"
                d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
              />
            </svg>
            Editar
          </button>
        </div>
      </div>

      <!-- Formulário -->
      <div class="info-form">
        <div class="campos-grid">
          <!-- Coluna Esquerda -->
          <div class="coluna">
            <div class="campo-grupo">
              <label class="campo-label">Imagem da Ação</label>
              <div
                class="input-imagem-container"
                v-show="modoEditar"
                style="margin-bottom: 12px"
              >
                <input
                  type="file"
                  class="imagem-upload-input-novo"
                  accept="image/*"
                  @change="onImagemSelecionada"
                  title="Alterar imagem"
                  ref="inputImagem"
                />
              </div>

              <div
                v-if="imagemAtual"
                class="imagem-preview-container"
              >
                <img
                  :src="imagemAtual"
                  alt="Imagem da Ação"
                  class="imagem-preview-img"
                />
                <button
                  v-if="modoEditar"
                  @click.prevent="removerImagem"
                  class="btn-excluir-foto"
                  title="Remover imagem"
                >
                  X
                </button>
              </div>

              <div
                v-if="!modoEditar && !imagemAtual"
                class="imagem-placeholder"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zM10.5 8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"
                  />
                  <path
                    d="M1 11.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-1.5v1.5a.5.5 0 0 1-1 0zm0 3v-1.5a.5.5 0 0 1 1 0V14h1.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm14-3v-1.5a.5.5 0 0 0-1 0V13h-1.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 .5-.5zm0 3v-2a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0 0 1h1.5v1.5a.5.5 0 0 0 1 0z"
                  />
                </svg>
                <span>Sem imagem</span>
              </div>
            </div>

            <div class="campo-grupo">
              <label class="campo-label">Título</label>
              <input
                type="text"
                class="campo-input"
                v-model="formData.titulo"
                :disabled="!modoEditar"
              />
            </div>

            <div class="campo-grupo">
              <label class="campo-label">Área Temática</label>
              <input
                type="text"
                class="campo-input"
                v-model="formData.areaTematica"
                :disabled="!modoEditar"
                placeholder="Ex: TECNOLOGIA_E_PRODUCAO"
              />
            </div>

            <div class="campo-grupo">
              <label class="campo-label">Coordenador</label>
              <div class="campo-coordenador-container">
                <input
                  type="text"
                  class="campo-input input-coordenador"
                  :value="acao.nomeCoordenador || '—'"
                  disabled
                />
                <button
                  v-if="!isCoordenadorDaAcao"
                  type="button"
                  class="btn-falar-coordenador"
                  @click="abrirModalFaleConosco"
                  title="Falar com coordenador"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M16 8c0 3.866-3.582 7-8 7a9 9 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7M5 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
                    />
                  </svg>
                  <span>Falar com coordenador</span>
                </button>
              </div>
            </div>

            <div class="linha-datas">
              <div class="campo-grupo">
                <label class="campo-label">Data de Início</label>
                <input
                  type="date"
                  class="campo-input"
                  v-model="formData.dataInicio"
                  disabled
                />
              </div>
              <div class="campo-grupo">
                <label class="campo-label">Data de Fim</label>
                <input
                  type="date"
                  class="campo-input"
                  v-model="formData.dataFim"
                  disabled
                />
              </div>
            </div>
          </div>

          <!-- Coluna Direita -->
          <div class="coluna">
            <div class="campo-grupo">
              <label class="campo-label">Sigla da Ação</label>
              <div class="campo-com-acao">
                <input
                  type="text"
                  class="campo-input"
                  :value="acao.sigla || 'Sem sigla'"
                  :disabled="!modoEditar || !isCoordenadorDaAcao"
                  :style="modoEditar && isCoordenadorDaAcao ? 'cursor: pointer;' : ''"
                  @click="modoEditar && isCoordenadorDaAcao ? abrirModalSigla() : null"
                  :title="modoEditar && isCoordenadorDaAcao ? 'Clique para editar a sigla e cor' : ''"
                />
              </div>
            </div>

            <div class="campo-grupo">
              <label class="campo-label">Descrição</label>
              <textarea
                class="campo-input"
                v-model="formData.descricao"
                :disabled="!modoEditar"
                rows="8"
                style="resize: vertical; min-height: 180px"
              ></textarea>
            </div>

            <!-- Objetivos Específicos -->
            <div class="campo-grupo">
              <label class="campo-label">Objetivos Específicos</label>

              <!-- Input para adicionar (só no modo editar) -->
              <div
                v-if="modoEditar"
                class="objetivo-input-wrapper"
              >
                <input
                  type="text"
                  class="campo-input objetivo-input"
                  v-model="novoObjetivo"
                  placeholder="Digite um objetivo e pressione Enter"
                  @keydown.enter.prevent="adicionarObjetivo"
                  maxlength="200"
                />
                <button
                  type="button"
                  class="btn-add-objetivo"
                  @click="adicionarObjetivo"
                  :disabled="!novoObjetivo.trim()"
                >
                  + Adicionar
                </button>
              </div>

              <!-- Lista de objetivos (tags) -->
              <div
                v-if="formData.objetivosEspecificos.length > 0"
                class="objetivos-lista"
              >
                <div
                  v-for="(obj, index) in formData.objetivosEspecificos.slice(
                    0,
                    5
                  )"
                  :key="obj.id || index"
                  class="objetivo-tag"
                  :title="obj.titulo"
                >
                  <span class="objetivo-texto">{{ obj.titulo }}</span>
                  <button
                    :disabled="!(!obj.id || obj.deleteIsPossible)"
                    type="button"
                    :class="
                      obj.deleteIsPossible
                        ? 'objetivo-remover'
                        : 'objetivo-nao-remover'
                    "
                    @click="removerObjetivo(index, obj)"
                    :title="
                      obj.deleteIsPossible === true
                        ? 'Excluir objetivo'
                        : 'Esse objetivo não pode ser excluído, pois está vinculada a uma ou várias atividades!'
                    "
                  >
                    ✕
                  </button>
                </div>
                <span
                  v-if="formData.objetivosEspecificos.length > 5"
                  class="objetivo-mais"
                >
                  +{{ formData.objetivosEspecificos.length - 5 }} mais
                </span>
              </div>

              <p
                v-else-if="!modoEditar"
                class="objetivo-vazio"
              >
                Nenhum objetivo cadastrado.
              </p>
            </div>

            <div class="campo-grupo campo-vazio">
              <!-- Espaçador vazio no lugar da DataFim que foi para a esquerda -->
            </div>
          </div>
        </div>

        <!-- Preview do Card -->
        <div
          v-if="modoEditar"
          class="preview-secao"
        >
          <h4 class="preview-titulo">Preview do Card na Listagem</h4>
          <div class="conteudo-preview">
            <div class="imagem-conteudo-acao">
              <img
                v-if="imagemAtual"
                :src="imagemAtual"
                alt="Imagem da Ação"
              />
              <img
                v-else
                src="@/assets/logoGex1.2.png"
                alt="Logo GEX"
              />
            </div>
            <div class="conteudo-listagem-acao">
              <div class="cima-conteudo-acao">
                <h5>{{ formData.titulo || "Sem título" }}</h5>
                <p class="descricao-texto">
                  <b>Descrição: </b>
                  {{ formData.descricao || "Sem descrição informada." }}
                </p>
              </div>
              <div class="baixo-conteudo-acao">
                <p>
                  <b>Área Temática: </b>
                  {{ formData.areaTematica || "Não informada" }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Botões de ação -->
        <div
          v-if="modoEditar"
          class="info-acoes"
        >
          <button
            class="btn-cancelar"
            @click="cancelarEdicao"
          >
            Cancelar
          </button>
          <button
            class="btn-salvar"
            @click="salvarAlteracoes"
            :disabled="salvando"
          >
            {{ salvando ? "Salvando..." : "Salvar Alterações" }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de edição da sigla -->
    <ModalEditarSigla
      :mostrar="modalSiglaVisivel"
      :acaoId="acaoId"
      :siglaAtual="acao.sigla"
      :corAtual="acao.corSigla"
      @fechar="fecharModalSigla"
      @atualizado="onSiglaAtualizada"
    />
    <ModalFaleConosco
      :mostrar="modalFaleConoscoVisivel"
      :acaoId="acaoId"
      :tituloAcao="acao.titulo"
      @fechar="fecharModalFaleConosco"
    />
    <!-- Modal de membros da equipe -->
    <ModalMembrosEquipe
      :mostrar="modalMembrosVisivel"
      :acaoId="acao.id || acaoId"
      :nomeAcao="acao.titulo"
      :imagemAcao="imagemAtual"
      @fechar="fecharModalMembros"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, watch, reactive, computed } from "vue";
import acaoService from "@/service/acaoService";
import objetivosService from "@/service/objetivosService";
import Carregamento from "@/components/common/Carregamento.vue";
import ModalEditarSigla from "@/components/acoes/ModalEditarSigla.vue";
import ModalFaleConosco from "@/components/ajuda/ModalFaleConosco.vue";
import ModalMembrosEquipe from "@/components/acoes/ModalMembrosEquipe.vue";
import ModalDeConfirmacao from "@/components/common/modalDeConfirmacao.vue";
const props = defineProps({
  acaoId: {
    type: [String, Number],
    required: true,
  },
  isCoordenador: {
    type: Boolean,
    default: false,
  },
});

const carregando = ref(true);
const salvando = ref(false);
const modoEditar = ref(false);
const modalSiglaVisivel = ref(false);
const modalFaleConoscoVisivel = ref(false);
const modalMembrosVisivel = ref(false);
const isCoordenadorDaAcao = ref(false);
const inputImagem = ref(null);
const novoObjetivo = ref("");

const acao = ref({});
const formData = reactive({
  titulo: "",
  descricao: "",
  areaTematica: "",
  dataInicio: "",
  dataFim: "",
  imagemArquivo: null,
  imagemUrlPreview: null,
  objetivosEspecificos: [],
});

const imagemAtual = computed(() => {
  if (formData.imagemUrlPreview) return formData.imagemUrlPreview;
  if (acao.value?.imagemUrl) return acao.value.imagemUrl;
  if (acao.value?.imagem?.url) return acao.value.imagem.url;
  if (acao.value?.imagem?.base64Data) {
    return `data:${acao.value.imagem.mimeType || "image/png"};base64,${
      acao.value.imagem.base64Data
    }`;
  }
  return null;
});

// Snapshot para cancelar
let snapshot = {};

async function buscarDadosAcao() {
  carregando.value = true;
  try {
    // 1. Busca os dados completos da ação
    const response = await acaoService.getAcoesById(props.acaoId);
    acao.value = response || {};
    sincronizarForm();

    // 2. Verificar permissão de coordenador desta ação específica com try/catch isolado
    try {
      const ehCoord = await acaoService.verificarCoordenador(props.acaoId);
      isCoordenadorDaAcao.value = !!ehCoord;
    } catch (e) {
      isCoordenadorDaAcao.value = false;
    }
  } catch (error) {
    console.error("Erro ao buscar dados da ação:", error);
  } finally {
    carregando.value = false;
  }
}

function sincronizarForm() {
  formData.titulo = acao.value.titulo || "";
  formData.descricao = acao.value.descricao || "";
  formData.areaTematica = acao.value.areaTematica || "";
  formData.dataInicio = acao.value.dataInicio || "";
  formData.dataFim = acao.value.dataFim || "";
  formData.imagemArquivo = null;
  formData.imagemUrlPreview = null;
  formData.objetivosEspecificos = Array.isArray(acao.value.objetivos)
    ? acao.value.objetivos
        .map((o) => {
          if (typeof o === "string") {
            return { id: null, titulo: o, deleteIsPossible: true };
          }
          return {
            id: o.id || o.uuid || null,
            titulo: o.titulo || "",
            deleteIsPossible: o.deleteIsPossible !== false,
          };
        })
        .filter((o) => o.titulo)
    : [];
}

function adicionarObjetivo() {
  const texto = novoObjetivo.value.trim();
  if (!texto) return;
  // Novo objetivo vai para o topo da lista
  formData.objetivosEspecificos.unshift({
    id: null,
    titulo: texto,
    deleteIsPossible: true,
  });
  novoObjetivo.value = "";
}

async function removerObjetivo(index, obj) {
  // Se for um objetivo novo ainda não salvo no banco
  if (!obj.id) {
    formData.objetivosEspecificos.splice(index, 1);
    return;
  }

  // Se for um objetivo já cadastrado e deletável
  if (!confirm(`Deseja realmente excluir o objetivo "${obj.titulo}"?`)) {
    return;
  }

  try {
    await objetivosService.deletarObjetivo(obj.id);
    formData.objetivosEspecificos.splice(index, 1);
    alert("Objetivo excluído com sucesso!");
  } catch (error) {
    alert("Erro ao excluir o objetivo. Tente novamente.");
  }
}

function ativarModoEditar() {
  snapshot = {
    ...formData,
    objetivosEspecificos: formData.objetivosEspecificos.map((o) => ({ ...o })),
  };
  modoEditar.value = true;
}

function cancelarEdicao() {
  Object.assign(formData, {
    ...snapshot,
    objetivosEspecificos: (snapshot.objetivosEspecificos || []).map((o) => ({
      ...o,
    })),
  });
  novoObjetivo.value = "";
  modoEditar.value = false;
}

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

async function salvarAlteracoes() {
  if (!formData.titulo.trim()) {
    alert("O título não pode estar vazio.");
    return;
  }

  salvando.value = true;
  try {
    const payload = {
      titulo: formData.titulo,
      dataInicio: formData.dataInicio,
      dataFim: formData.dataFim,
      sigla: acao.value.sigla,
      corSigla: acao.value.corSigla,
      descricao: formData.descricao,
      areaTematica: formData.areaTematica,
      objetivos: formData.objetivosEspecificos.map((o) => {
        if (!o.id) {
          return {
            id: null,
            titulo: o.titulo,
            deleteIsPossible: true,
          };
        }
        return {
          id: o.id,
          titulo: o.titulo,
        };
      }),
    };

    // Passa a imagem em base64 se houver
    if (formData.imagemArquivo) {
      const base64Str = await fileToBase64(formData.imagemArquivo);
      payload.imagem = {
        mimeType: formData.imagemArquivo.type,
        base64Data: base64Str,
        creditosImagem: "Imagem da Ação",
      };
    }

    await acaoService.editarAcao(props.acaoId, payload);

    // Atualiza os dados na tela com os novos do back-end
    await buscarDadosAcao();

    modoEditar.value = false;
    alert("Alterações salvas com sucesso!");
  } catch (error) {
    alert("Erro ao salvar alterações. Verifique sua conexão.");
  } finally {
    salvando.value = false;
  }
}

function onImagemSelecionada(event) {
  const file = event.target.files[0];
  if (file) {
    formData.imagemArquivo = file;
    formData.imagemUrlPreview = URL.createObjectURL(file);
  }
}

function removerImagem() {
  formData.imagemArquivo = null;
  formData.imagemUrlPreview = null;
  if (acao.value) {
    acao.value.imagemUrl = null;
    if (acao.value.imagem) {
      acao.value.imagem = null;
    }
  }
  if (inputImagem.value) {
    inputImagem.value.value = "";
  }
}

function abrirModalSigla() {
  modalSiglaVisivel.value = true;
}

function fecharModalSigla() {
  modalSiglaVisivel.value = false;
}

function onSiglaAtualizada() {
  modalSiglaVisivel.value = false;
  buscarDadosAcao();
}

function abrirModalFaleConosco() {
  modalFaleConoscoVisivel.value = true;
}

function fecharModalFaleConosco() {
  modalFaleConoscoVisivel.value = false;
}

function abrirModalMembros() {
  modalMembrosVisivel.value = true;
}

function fecharModalMembros() {
  modalMembrosVisivel.value = false;
}

watch(
  () => props.acaoId,
  (novoId) => {
    if (novoId) {
      modoEditar.value = false;
      buscarDadosAcao();
    }
  }
);

onMounted(() => {
  buscarDadosAcao();
});
</script>

<style scoped>
.info-acao-container {
  width: 100%;
  padding: 24px 16px;
  font-family: var(--font-base);
  display: flex;
  justify-content: center;
}

.info-acao-wrapper {
  width: 100%;
  max-width: 100%;
}

/* ========== ACESSO NEGADO ========== */
.acesso-negado {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 64px 24px;
}

.mensagem-negada {
  text-align: center;
  color: hsl(260, 20%, 40%);
  max-width: 400px;
}

.mensagem-negada svg {
  color: var(--roxo-escuro1);
  margin-bottom: 16px;
  opacity: 0.8;
}

.mensagem-negada h3 {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 600;
  color: hsl(260, 25%, 20%);
}

.mensagem-negada p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
}

/* ========== TÍTULO DA SEÇÃO ========== */
.info-titulo-secao {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.info-titulo-secao h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: hsl(260, 25%, 20%);
}

.btn-editar-principal {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 24px;
  border: 1.5px solid var(--roxo-escuro1);
  border-radius: 8px;
  background: transparent;
  color: var(--roxo-escuro1);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: var(--font-base);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
}

.btn-editar-principal:hover {
  background: var(--roxo-escuro1);
  color: #fff;
}

/* ========== FORMULÁRIO ========== */
.info-form {
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.campos-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 32px;
  width: 100%;
}

.coluna {
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
  width: 100%;
}

.campo-grupo {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  width: 100%;
}

.campo-grupo.campo-vazio {
  display: none;
}

.linha-datas {
  display: flex;
  gap: 16px;
  width: 100%;
}

.linha-datas .campo-grupo {
  flex: 1;
}

@media (min-width: 992px) {
  .campo-grupo.campo-vazio {
    display: block;
  }
}
.campo-label {
  font-size: 12px;
  font-weight: 600;
  color: hsl(260, 10%, 50%);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.campo-input {
  width: 100%;
  padding: 12px 16px;
  border: 1.5px solid hsl(260, 30%, 85%);
  border-radius: 8px;
  font-size: 14px;
  font-family: var(--font-base);
  color: hsl(260, 10%, 20%);
  background-color: hsl(260, 20%, 97%);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
}

.campo-input:not(:disabled) {
  background-color: #fff;
  border-color: hsl(265, 45%, 55%);
}

.campo-input:not(:disabled):focus {
  outline: none;
  border-color: hsl(265, 55%, 45%);
  box-shadow: 0 0 0 3px hsla(265, 55%, 45%, 0.12);
}

.campo-input:disabled {
  cursor: not-allowed;
  opacity: 0.85;
}

/* ========== IMAGEM ========== */
.imagem-preview-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.imagem-preview-img {
  width: 200px;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
  border: 1.5px solid hsl(260, 30%, 80%);
}

.btn-excluir-foto {
  padding: 8px 14px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
  height: fit-content;
}

.btn-excluir-foto:hover {
  background-color: #bd2130;
}

.imagem-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: hsl(260, 20%, 60%);
  background-color: hsl(260, 20%, 95%);
  border: 1.5px dashed hsl(260, 30%, 80%);
  border-radius: 8px;
  height: 200px;
  width: 100%;
}

.imagem-upload-input-novo {
  width: 100%;
  padding: 8px;
  border: 1.5px solid hsl(260, 30%, 85%);
  border-radius: 8px;
  background-color: #fff;
  font-family: var(--font-base);
  color: hsl(260, 10%, 20%);
}

/* ========== CAMPO COM BOTÃO ========== */
.campo-com-acao {
  display: flex;
  gap: 12px;
  align-items: center;
}

.campo-com-acao .campo-input {
  flex: 1;
}

.btn-campo-acao {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: var(--roxo-escuro1);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  font-family: var(--font-base);
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-campo-acao:hover {
  background: hsl(265, 55%, 30%);
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

/* ========== BOTÕES DE AÇÃO ========== */
.info-titulo-secao {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid hsl(260, 20%, 90%);
  padding-bottom: 16px;
  margin-bottom: 32px;
}

.botoes-topo {
  display: flex;
  gap: 12px;
  align-items: center;
}

.btn-membros-equipe {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 1.5px solid var(--roxo-escuro1);
  border-radius: 8px;
  background: #ffffff;
  color: var(--roxo-escuro1);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  font-family: var(--font-base);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
}

.btn-membros-equipe:hover {
  background: hsl(265, 45%, 96%);
}

.btn-membros-equipe:active {
  transform: scale(0.98);
}

.campo-coordenador-container {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
}

.input-coordenador {
  flex: 1 1 auto;
  min-width: 0;
}

.btn-falar-coordenador {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #ffffff;
  border: 1.5px solid var(--roxo-escuro1);
  color: var(--roxo-escuro1);
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: var(--font-base);
}

.btn-falar-coordenador:hover {
  background: hsl(265, 45%, 96%);
}

.btn-falar-coordenador:active {
  transform: scale(0.98);
}

@media (max-width: 600px) {
  .campo-coordenador-container {
    flex-direction: column;
    align-items: stretch;
  }

  .btn-falar-coordenador {
    justify-content: center;
  }
}

.info-acoes {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid hsl(260, 20%, 92%);
}

.btn-salvar {
  padding: 12px 32px;
  background: var(--roxo-escuro1);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  font-family: var(--font-base);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-salvar:hover {
  background: hsl(265, 55%, 30%);
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.btn-salvar:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-cancelar {
  padding: 12px 32px;
  background: transparent;
  color: var(--roxo-escuro1);
  border: 1.5px solid var(--roxo-escuro1);
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  font-family: var(--font-base);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-cancelar:hover {
  background: hsl(265, 80%, 97%);
}

/* ========== PREVIEW DO CARD ========== */
.preview-secao {
  margin-top: 32px;
  padding-top: 32px;
  border-top: 1px dashed hsl(260, 20%, 85%);
}

.preview-titulo {
  font-size: 12px;
  font-weight: 600;
  color: hsl(260, 10%, 50%);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 16px;
}

.conteudo-preview {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  justify-content: space-between;
  align-items: center;
  background-color: rgba(217, 217, 217, 1);
  border-radius: 0.5rem;
  padding: 24px 20px;
  width: 100%;
  pointer-events: none; /* Só visualização */
}

.conteudo-preview .imagem-conteudo-acao {
  height: 183px;
  width: 283px;
  border-radius: 0.5rem;
  overflow: hidden;
  background-color: #563578;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.conteudo-preview .imagem-conteudo-acao img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.conteudo-preview .conteudo-listagem-acao {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 183px;
  width: 100%;
  text-align: left;
  padding: 0px 15px;
  color: black;
}

.conteudo-preview .cima-conteudo-acao h5 {
  font-size: 1.95rem;
  font-weight: 500;
  margin: 0 0 10px 0;
}

.conteudo-preview .cima-conteudo-acao p,
.conteudo-preview .baixo-conteudo-acao p {
  font-size: 15px;
  margin: 0;
}

.conteudo-preview .descricao-texto {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  white-space: normal;
  text-align: left;
  line-height: 1.4;
}

/* ========== RESPONSIVO ========== */
@media (max-width: 768px) {
  .info-acao-container {
    padding: 16px 8px;
  }

  .info-form {
    padding: 24px 16px;
  }

  .campos-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .campo-vazio {
    display: none;
  }

  .campo-com-acao {
    flex-direction: column;
    align-items: stretch;
  }

  .info-acoes {
    flex-direction: column-reverse;
  }

  .btn-salvar,
  .btn-cancelar {
    width: 100%;
    text-align: center;
    justify-content: center;
  }
}

/* ── Objetivos Específicos ── */
.objetivo-input-wrapper {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.objetivo-input {
  flex: 1;
  margin-bottom: 0 !important;
}

.btn-add-objetivo {
  flex-shrink: 0;
  padding: 0 16px;
  height: 40px;
  border-radius: 8px;
  border: 1.5px solid #3b2078;
  background: #ffffff;
  color: #3b2078;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
}

.btn-add-objetivo:hover:not(:disabled) {
  background: #3b2078;
  color: #ffffff;
}

.btn-add-objetivo:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.objetivos-lista {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 100%;
}

.objetivo-tag {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background: hsl(255, 50%, 97%);
  border: 1px solid hsl(255, 30%, 88%);
  border-radius: 8px;
  padding: 8px 12px;
  box-shadow: 0 1px 2px rgba(59, 32, 120, 0.06);
  transition: all 0.15s ease;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.objetivo-tag:hover {
  border-color: hsl(255, 40%, 75%);
  background: hsl(255, 50%, 95%);
}

.objetivo-texto {
  font-size: 13px;
  color: #3b2078;
  font-weight: 500;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
  display: block;
}

.objetivo-nao-remover {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: none;
  background: hsl(255, 30%, 88%);
  color: #5b4fa0;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  padding: 0;
}

.objetivo-remover {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: none;
  background: hsl(255, 30%, 88%);
  color: #5b4fa0;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  padding: 0;
}

.objetivo-remover:hover {
  background: #e53935;
  color: #ffffff;
  box-shadow: 0 1px 3px rgba(229, 57, 53, 0.35);
}

.objetivo-mais {
  font-size: 12px;
  color: #6b7280;
  font-style: italic;
  padding: 4px 0;
}

.objetivo-vazio {
  font-size: 13px;
  color: #9ca3af;
  margin: 0;
  font-style: italic;
}
</style>
